module.exports = __webpack_public_path__ + "media/bootstrap-icons/toggle2-on-fa1fc8d0.svg";